// extracted by mini-css-extract-plugin
export default {"container":"SlackRedirect_container__u1AfP"};